import { useState, useEffect, useRef } from 'react';

const FotoVideographieProcess = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [visibleItems, setVisibleItems] = useState<number[]>([]);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            setTimeout(() => setVisibleItems(prev => [...prev, 0]), 200);
            setTimeout(() => setVisibleItems(prev => [...prev, 1]), 400);
            setTimeout(() => setVisibleItems(prev => [...prev, 2]), 600);
            setTimeout(() => setVisibleItems(prev => [...prev, 3]), 800);
            setTimeout(() => setVisibleItems(prev => [...prev, 4]), 1000);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const steps = [
    {
      number: '01',
      title: 'Briefing & Konzeption',
      description: 'Wir besprechen Ihre Ziele, Zielgruppe und entwickeln ein maßgeschneidertes Konzept für Ihr Projekt.',
      icon: 'ri-lightbulb-line'
    },
    {
      number: '02',
      title: 'Planung & Vorbereitung',
      description: 'Detailplanung des Shootings, Location-Scouting, Equipment-Auswahl und Terminkoordination.',
      icon: 'ri-calendar-check-line'
    },
    {
      number: '03',
      title: 'Produktion',
      description: 'Professionelle Durchführung des Foto- oder Video-Shootings mit modernster Technik.',
      icon: 'ri-camera-3-line'
    },
    {
      number: '04',
      title: 'Post-Production',
      description: 'Sorgfältige Nachbearbeitung, Farbkorrektur und Optimierung für verschiedene Verwendungszwecke.',
      icon: 'ri-edit-2-line'
    },
    {
      number: '05',
      title: 'Auslieferung',
      description: 'Lieferung der finalen Dateien in verschiedenen Formaten und Auflösungen für alle Ihre Bedürfnisse.',
      icon: 'ri-download-cloud-line'
    }
  ];

  return (
    <section ref={sectionRef} className="py-32 bg-zinc-950">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className={`text-center mb-20 transition-all duration-1000 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <span className="text-[#d1bc8a] text-sm uppercase tracking-[0.3em] font-light mb-6 block">
            Unser Prozess
          </span>
          <h2 className="text-5xl md:text-7xl font-bold text-white mb-6">
            Von der Idee
            <br />
            <span className="text-[#d1bc8a]">zum perfekten Bild</span>
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto font-light">
            Unser strukturierter Produktionsprozess garantiert professionelle Ergebnisse und eine reibungslose Zusammenarbeit
          </p>
        </div>

        {/* Process Steps */}
        <div className="space-y-16 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`flex flex-col lg:flex-row items-center gap-12 transition-all duration-1000 ${
                visibleItems.includes(index) ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
              } ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}
              style={{ transitionDelay: `${index * 200}ms` }}
            >
              {/* Content */}
              <div className="flex-1 text-center lg:text-left">
                <div className="flex items-center justify-center lg:justify-start space-x-4 mb-6">
                  <span className="text-6xl font-bold text-zinc-800">{step.number}</span>
                  <div className="w-12 h-px bg-zinc-700"></div>
                </div>
                <h3 className="text-3xl font-bold text-white mb-4">{step.title}</h3>
                <p className="text-lg text-white/60 leading-relaxed max-w-lg">
                  {step.description}
                </p>
              </div>

              {/* Icon */}
              <div className="flex-shrink-0">
                <div className="w-32 h-32 rounded-full bg-[#d1bc8a]/10 border-2 border-[#d1bc8a]/30 flex items-center justify-center hover:bg-[#d1bc8a]/20 hover:scale-110 transition-all duration-300">
                  <i className={`${step.icon} text-4xl text-[#d1bc8a]`}></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FotoVideographieProcess;